<button (click)="form()" class="button" matButton="elevated">
  <mat-icon fontIcon="auto_awesome"/>
  Hämta blankett Mall vid låneupplägg
</button>
